import { render, staticRenderFns } from "./_AboutRoomOccupant.vue?vue&type=template&id=5b2b759e"
import script from "./_AboutRoomOccupant.vue?vue&type=script&lang=js"
export * from "./_AboutRoomOccupant.vue?vue&type=script&lang=js"
import style0 from "./_AboutRoomOccupant.vue?vue&type=style&index=0&id=5b2b759e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports